<template>

    <b-row>

        <b-col>

            <b-form-group label="First Name *" label-for="firstname">

                <b-form-input
                    name="firstname"
                    type="text"
                    v-model="form.firstname"
                >
                </b-form-input>
                <input-help :form="form" field="firstname" text=""></input-help>
            </b-form-group>

            <b-form-group label="Last Name *" label-for="lastname">

                <b-form-input
                    name="lastname"
                    type="text"
                    v-model="form.lastname"
                    >
                </b-form-input>
                <input-help :form="form" field="lastname" text=""></input-help>
            </b-form-group>

            <b-form-group label="Email Address *" label-for="email">

                <b-form-input
                    name="email"
                    type="text"
                    v-model="form.email"
                    >
                </b-form-input>
                <input-help :form="form" field="email" text=""></input-help>
            </b-form-group>

            <div class="d-flex align-items-end flex-column">

                <b-button variant="success" size="lg" :disabled=" loading " @click=" submit ">{{ buttonLabel }} Manager</b-button>
                <p class="text-muted small mt-2">This will email the manager and prompt them to set a password for themselves</p>
            </div>
        </b-col>
    </b-row>
</template>

<script>

    export default {

        name: "BusinessClient",

        mixins: [],

        props: {

            carrier: {

                type     : Object,
                required : true
            },
            loadTable : Function,
            editingUser: {

                type    : Object,
                default : {}
            }
        },

        data() {

            return {

                loading : false,
                form    : new Form({
                    id             : null,
                    firstname      : '',
                    lastname       : '',
                    email          : '',
                    ltc_carrier_id : this.carrier.id
                })
            }
        },

        computed: {

            buttonLabel(){

                return this.form.id ? 'Update' : 'Create';
            }
        },

        methods: {

            submit(){

                this.loading = true;
                const action = this.form.id ? 'patch' : 'post';
                const url = '/business/carrier_managers' + ( this.form.id ? `/${this.form.id}` : '' );
                this.form.submit( action, url )
                .then( res => {

                    this.loadTable();
                })
                .catch( err => {

                    console.error( 'creation error detected!', err );
                })
                .finally( () => {

                    this.loading = false;
                })
            },
            setForm( val ){

                this.form = new Form({

                    id             : val ? val.id : null,
                    firstname      : val ? val.firstname : '',
                    lastname       : val ? val.lastname : '',
                    email          : val ? val.email : '',
                    ltc_carrier_id : this.carrier.id
                })
            }
        },

        mounted() {

        },

        watch: {

            editingUser: {

                immediate: true,
                handler( newVal, oldVal ){

                    if( !_.isEmpty( newVal ) && newVal.id ) this.setForm( newVal );
                }
            }
        }
    }
</script>
